module.exports = __webpack_public_path__ + "static/media/match-pair.e31e40cf.svg";